var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoSmall = function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    fill: "none",
    viewBox: "0 0 35 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-small_svg__a)",
    fillRule: "evenodd",
    d: "M16.118.355 1.296 8.987A2.61 2.61 0 0 0 0 11.241v17.518c0 .928.493 1.786 1.296 2.254l14.822 8.632a2.61 2.61 0 0 0 2.638-.004l14.698-8.627a2.61 2.61 0 0 0 1.288-2.249v-17.53c0-.925-.49-1.78-1.288-2.25L18.756.36a2.61 2.61 0 0 0-2.638-.004m-.025 7.618-8.128 4.733A2.61 2.61 0 0 0 6.67 14.96v9.642c0 .927.494 1.786 1.296 2.253l8.128 4.733a2.61 2.61 0 0 0 2.637-.004l8.055-4.728a2.61 2.61 0 0 0 1.288-2.249v-9.653c0-.925-.49-1.78-1.288-2.25L18.73 7.978a2.61 2.61 0 0 0-2.637-.004",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M27.716 25.924c.23-.393.357-.846.357-1.317V13.785l6.405-3.694a2.6 2.6 0 0 0-1.024-1.105L18.756.359a2.61 2.61 0 0 0-2.637-.004L1.296 8.987a2.6 2.6 0 0 0-1.03 1.105l6.403 3.693z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#38383A",
    fillRule: "evenodd",
    d: "M17.371 0a2.6 2.6 0 0 0-1.252.355L1.296 8.987a2.6 2.6 0 0 0-1.03 1.105l6.403 3.693v10.816c0 .473.128.928.36 1.322l10.342-5.965z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-small_svg__a",
    x1: 31.66,
    x2: -40.024,
    y1: 1.104,
    y2: 24.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgLogoSmall;